import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { getOperateConfig, postOperateSaveConfig, postOperateUploadImage } from '@blade-sxp/portal-settings/api/user';
import { includes, last, toLower } from 'lodash';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
let portalSettings = class portalSettings extends Vue {
    currentLanguage = 'ENGLISH';
    systemName = '';
    saveDisabled = true;
    logoUrl = '';
    thumbnailUrl = '';
    uploadLogoUrl = '';
    uploadThumbnailUrl = '';
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    logoLoading = false;
    thumbnailLoading = false;
    languageOptions = [
        { text: String(this.$t('english')), value: 'ENGLISH' },
        { text: String(this.$t('chinese')), value: 'CHINESE' },
    ];
    initI18n() {
        this.languageOptions = [
            { text: String(this.$t('english')), value: 'ENGLISH' },
            { text: String(this.$t('chinese')), value: 'CHINESE' },
        ];
    }
    onSystemNameChange(val) {
        let getPortalData = JSON.parse(localStorage.getItem('portalData') || '');
        if (val !== getPortalData.systemName) {
            this.saveDisabled = false;
        }
    }
    onLogoUrlChange(val) {
        let getPortalData = JSON.parse(localStorage.getItem('portalData') || '');
        if (val !== getPortalData.defaultLogoUrl) {
            this.saveDisabled = false;
        }
    }
    onThumbnailUrlChange(val) {
        let getPortalData = JSON.parse(localStorage.getItem('portalData') || '');
        if (val !== getPortalData.menuShrinkageLogoUrl) {
            this.saveDisabled = false;
        }
    }
    onCurrentLanguageChange(val) {
        let getPortalData = JSON.parse(localStorage.getItem('portalData') || '');
        if (val !== getPortalData.language) {
            this.saveDisabled = false;
        }
    }
    convertBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (e) => reject(e);
        }).catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    handleLogoSuccess(file) {
        const { name, size } = file;
        if (this.isFormatValid(name, size)) {
            this.converImg('logo', file);
        }
        else {
            this.$elmessage.error(this.$t('textTips').toString());
        }
        return false;
    }
    handleThumbnailSuccess(file) {
        const { name, size } = file;
        if (this.isFormatValid(name, size)) {
            this.converImg('thumbnail', file);
        }
        else {
            this.$elmessage.error(this.$t('textTips').toString());
        }
        return false;
    }
    async converImg(type, file) {
        const base64Image = (await this.convertBase64(file));
        this.transformUploadImage(type, base64Image);
    }
    isFormatValid(name, size) {
        const suffix = last(name.split('.'));
        const nameValid = includes(['jpg', 'png', 'jpeg'], toLower(suffix));
        const maxSize = Number(1024 * 1024) || 0;
        const sizeValid = maxSize <= 0 || size <= maxSize;
        return nameValid && sizeValid;
    }
    removeLogo() {
        this.logoUrl = '';
        this.uploadLogoUrl = '';
    }
    removeThumbnail() {
        this.thumbnailUrl = '';
        this.uploadThumbnailUrl = '';
    }
    handelCancel() {
        this.init();
    }
    transformUploadImage(type, val) {
        if (type === 'logo') {
            this.logoLoading = true;
        }
        else if (type === 'thumbnail') {
            this.thumbnailLoading = true;
        }
        this.saveDisabled = true;
        postOperateUploadImage({
            logoImage: val,
        })
            .then((res) => {
            if (type === 'logo') {
                this.uploadLogoUrl = res;
                this.logoUrl = val;
            }
            else if (type === 'thumbnail') {
                this.uploadThumbnailUrl = res;
                this.thumbnailUrl = val;
            }
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        })
            .finally(() => {
            this.logoLoading = false;
            this.thumbnailLoading = false;
            this.saveDisabled = false;
        });
    }
    handelSave() {
        postOperateSaveConfig({
            language: this.currentLanguage,
            defaultLogo: this.uploadLogoUrl,
            systemName: this.systemName,
            menuShrinkageLogo: this.uploadThumbnailUrl,
        })
            .then((res) => {
            if (res) {
                this.$message({ message: this.$t('result').toString(), type: 'success' });
                this.init();
            }
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    getUploadApiUrl(val) {
        let new_url = '';
        if (val !== '') {
            new_url = val.substring(val.indexOf('/logo-bucket/') + 13, val.indexOf('.') + 4);
        }
        return new_url;
    }
    init() {
        getOperateConfig()
            .then((res) => {
            this.currentLanguage = res.language !== '' ? res.language : this.currentLanguage;
            this.systemName = res.systemName ? res.systemName : '';
            this.logoUrl = res.defaultLogoUrl ? res.defaultLogoUrl : '';
            this.thumbnailUrl = res.menuShrinkageLogoUrl ? res.menuShrinkageLogoUrl : '';
            this.uploadLogoUrl = this.getUploadApiUrl(res.defaultLogoUrl);
            this.uploadThumbnailUrl = this.getUploadApiUrl(res.menuShrinkageLogoUrl);
            let portalData = {
                ...res,
            };
            localStorage.setItem('portalData', JSON.stringify(portalData));
            this.saveDisabled = true;
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    mounted() {
        this.init();
    }
};
__decorate([
    Watch('$i18n.locale')
], portalSettings.prototype, "initI18n", null);
__decorate([
    Watch('systemName')
], portalSettings.prototype, "onSystemNameChange", null);
__decorate([
    Watch('logoUrl')
], portalSettings.prototype, "onLogoUrlChange", null);
__decorate([
    Watch('thumbnailUrl')
], portalSettings.prototype, "onThumbnailUrlChange", null);
__decorate([
    Watch('currentLanguage')
], portalSettings.prototype, "onCurrentLanguageChange", null);
portalSettings = __decorate([
    Component({
        name: 'portalSettings',
        components: { BlurPicture },
        i18n: {
            messages: {
                'en-us': {
                    themeSettings: 'Theme Settings',
                    systemName: 'System Name',
                    defaultLogo: 'Default Logo',
                    foldedMenuLogo: 'Folded Menu Logo',
                    languageSettings: 'Language Settings',
                    defaultLanguage: 'Default Language',
                    english: 'English',
                    chinese: 'Chinese',
                    textTips: 'Drag PNG or JPG file here or click to upload; Max 1MB',
                    cancel: 'Cancel',
                    save: 'Save',
                    result: 'Operation successful',
                },
                zh: {
                    themeSettings: '主题设置',
                    systemName: '系统名称',
                    defaultLogo: '默认 LOGO',
                    foldedMenuLogo: '菜单收起 LOGO',
                    languageSettings: '语言设置',
                    defaultLanguage: '默认语言',
                    english: '英文',
                    chinese: '中文',
                    textTips: '图片格式 JPG、PNG，大小1M以内',
                    cancel: '取消',
                    save: '保存',
                    result: '操作成功',
                },
            },
        },
    })
], portalSettings);
export default portalSettings;
